import { Component, OnInit } from '@angular/core';

import { Router } from '@angular/router';
import { FormBuilder, FormGroup, Validators, FormsModule } from '@angular/forms';
import { first } from 'rxjs/operators';

//import { UserService } from '../../services/user.service';
import { CommonDataService } from '../../services/common-data.service';
import { CommerceDataService } from '../../services/commerce-data.service';
import { environment } from '../../../environments/environment';

declare var $:any;
declare var iziToast:any;

@Component({
  selector: 'app-checkout-review-page',
  templateUrl: './checkout-review-page.component.html',
  styleUrls: ['./checkout-review-page.component.css']
})
export class CheckoutReviewPageComponent implements OnInit {
  
  pageName = "Checkout / Review Details";

  cartItems = []
  numberOfItems = 0
  //calculated from the commerce data service
  cartTotalBreakDown
  cartItemsSubscription;
  shoppingCartEmpty
  cartPoints = 0

  modelId = '0';
  modelData: any;
  shippingCostValue = 0
  pageReady = false;

  //payment details
  paymentTransactionId = 0;
  paymentTransactionRef = '';
  checkComplete = false

  constructor(
    private formBuilder: FormBuilder,
    private router: Router,
    private _data: CommonDataService,
    private _ecomm: CommerceDataService
  ) { 

    $('#loader').show();
  }

  ngOnInit() {
    $('#initialise-page').trigger('click');

    

    let cartItems = localStorage.getItem("cartItems")
    
    if(cartItems) {
      this.cartItems = JSON.parse(localStorage.getItem("cartItems"))
      this.numberOfItems = this.cartItems.length
    }
    this.cartTotalBreakDown = this._ecomm.calculateCartTotal()
    this.cartPoints = this._ecomm.getCartEarnPoints()

    //Subscribe to the cart items changes and update this cart items every time there is new updates
    this.cartItemsSubscription = this._ecomm.cartItemsChanged.subscribe(
      (data) => {
        // this.cartItems = data;
        // console.log(this.cartItems)
        // this.numberOfItems = this.cartItems.length
        // this.cartTotalBreakDown = this._ecomm.calculateCartTotal()
        // this.cartPoints = this._ecomm.getCartEarnPoints()
        // this.router.navigate(['/shop/checkout/shipping']);

      }
    );

    let currentOrder = sessionStorage.getItem('order')
    if(currentOrder && parseInt(currentOrder) > 0) {
      this.modelId = currentOrder
      this.getOrderDetails()
      this.updateOrderCart()
    }

    else {
      //we need to send you back to checkout first page, so we can create an order for you
      let h = {
        class: "iziToast-warning",
        title:  "Order:",
        message:  "We need to capture you billing details first!",
        animateInside: !1,
        position: "topRight",
        progressBar: !1,
        icon: "icon-bell",
        timeout: 3200,
        transitionIn: "fadeInLeft",
        transitionOut: "fadeOut",
        transitionInMobile: "fadeIn",
        transitionOutMobile: "fadeOut",
      };
      iziToast.show(h);

      this.router.navigate(['/shop/checkout/address']);

    }

  }

  getOrderDetails() {
    let queryData = new FormData();
    queryData.append('modelName', 'Order');
    queryData.append('mid', this.modelId);

      $('#loader').show();
      //lets get the model for this page
      this._data.getModelData(queryData) 
      .pipe(first())
      .subscribe(
        data => {
          this.modelData = data['covers'][0]['cover']['model']['modelData']['formFieldsEntities'];
          this.shippingCostValue = parseFloat(this.modelData['shippingInfo']['totalCost'])
          
        },
        error => {

            // $('#loader').hide();

        },

        () => {
          // $('#loader').hide();
          // this.reviewOrderSummary()
        }
      );
  }

  getProductImageSrc(modelData){

    if( modelData['files'] && modelData['files']['uploads'] && Array.isArray(modelData['files']['uploads']) && modelData['files']['uploads'].length > 0) {
      let productImages = modelData['files']['uploads']

      for (let index = 0; index < productImages.length; index++) {
        let element = productImages[index];

        if(element['tmp_name'] && element['tmp_name'] != '') {
          let srcStrings = element['tmp_name'].split("public/");
          let src = environment.filesSrc+'/'+srcStrings[1]
          element['src'] = src
          return src
        }
        
      }

    }

      return ''
  }

  updateOrderCart() {

    //front end reviewOrder
    //first we add the cart items to the order
    let modelObject1 = new FormData();
    modelObject1.append('modelName', 'Order');
    modelObject1.append('id', this.modelId);
    modelObject1.append('cartItems-totalItems', this.numberOfItems+'');
    modelObject1.append('cartItems-rewardPoints', this.cartPoints+'');
    modelObject1.append('shopCartItems-products', JSON.stringify(this.cartItems));
    modelObject1.append('cartItems-products', JSON.stringify(this.cartItems));

    // for (let index = 0; index < this.cartItems.length; index++) {
    //   const item = this.cartItems[index];

    //   modelObject1.append('cartItems-products[]', JSON.stringify(item));
      
    // }

    this.updateOrderAndGetOrderSummaries(modelObject1);
    //on init call API and recalculate order summaries
    //create and get payment request id
    //get cart breakdown 
    //validate shipping quote and get shipping cost in cart breakdown above

  }

  reviewOrderSummary() {
    
    let modelObject1 = new FormData();
    modelObject1.append('id', this.modelId);

    this._data.dynamicFormPost(modelObject1, 'api-review-order-totals') 
      .pipe(first())
      .subscribe(
        data => {

          if(data['order'] != undefined) {
            this.cartTotalBreakDown['total'] = data['order']['totalProductsCost'];
            this.cartTotalBreakDown['vat'] = data['order']['totalTax'];
            this.cartTotalBreakDown['transactionFee'] = data['order']['transactionFee'];
            this.cartTotalBreakDown['totalInclusive'] = data['order']['totalInclusive'];
            this.cartTotalBreakDown['shippingTotal'] = data['order']['shippingTotal'];

            this.pageReady = true;

          }

          this.pageReady = true;
        },
        error => {$('#loader').hide();},
        () => {
          // this.reviewOrderSummary()
          $('#loader').hide();
        }
      );
  }

  updateOrderAndGetOrderSummaries (modelObject: any) {
    // Initiate new model creation/update method

    this._data.updateModelData(modelObject) 
      .pipe(first())
      .subscribe(
        data => {},
        error => {},
        () => {
          this.reviewOrderSummary()
        }
      );
  }

  getPaymentRequest() {
    let modelObject1 = new FormData();
    modelObject1.append('id', this.modelId);
    modelObject1.append('amount', this.cartTotalBreakDown['totalInclusive']);

    this._data.dynamicFormPost(modelObject1, 'get-payment-details') 
      .pipe(first())
      .subscribe(
        data => {

          if(data['transaction'] != undefined) {
            this.paymentTransactionId = data['transaction']['id'];
            this.paymentTransactionRef = data['transaction']['model']['modelData']['systemManagedEntities']['transaction_details']['transactionReference'];
            //save transaction 
            sessionStorage.setItem('txn', this.paymentTransactionRef);
          }

          if(data['pfObject']['Order'] != undefined) {
            this.createPaymentRequest(data['pfObject']['Order'])
          }

          this.pageReady = true;
        },
        error => {},
        () => {}
      );
  }

  createPaymentRequest(paymentDetails) {
    //create a hidden form for payfast
    //submit form and redirect to payfast
    //when complete success page or failed page
    // let testPayfastArray = {
    //   merchant_id: '10013995',
    //   merchant_key: 'u16jfkygcrj6k',
    //   name_first: 'Brian',
    //   name_last: 'Test',
    //   email_address: 'bsnyatsiner@gmail.com',
    //   cell_number: '0735211079',
    //   m_payment_id: 'refNumber',
    //   amount: 1700,
    //   item_name: 'simba test',
    //   signature: 'ff1c30e3484efa04c121d9ad22af8709'
    // }
    $('#loader').show();

    let txnPayfastArray = {
      merchant_id: paymentDetails['merchant_id'],
      merchant_key: paymentDetails['merchant_key'],
      // return_url: paymentDetails['return_url'],
      // cancel_url: paymentDetails['cancel_url'],
      notify_url: paymentDetails['notify_url'],
      name_first: paymentDetails['name_first'],
      name_last: paymentDetails['name_last'],
      email_address: paymentDetails['email_address'],
      cell_number: paymentDetails['cell_number'],
      m_payment_id: paymentDetails['m_payment_id'],
      amount: paymentDetails['amount'],
      item_name: paymentDetails['item_name'],
      signature: paymentDetails['signature']
    }

    for (const [key, value] of Object.entries(txnPayfastArray)) {
        console.log(key, value);

        $("<input>").attr({ 
          name: key, 
          id: key, 
          type: "hidden", 
          value: value 
      }).appendTo("#payfastform");


    }

    let formContent = $("#setForm").contents()

    $('#pf').contents().find('body').append(formContent);
    $('#pf').contents().find('form').submit();
    // $("#payfastform").submit();

    $('#mainReview').hide();
    $('#showPayment').show();

    this.trackPaymentStatus()

    setTimeout(function(){
      $('#loader').hide();
    },1200);

       

  }

  trackPaymentStatus() {

    if(this.checkComplete == false) {
      let queryData = new FormData();
      queryData.append('modelName', 'PaymentTransaction');
      queryData.append('transaction_details->transactionReference->systemManagedEntities', this.paymentTransactionRef);
  
        // $('#loader').show();
        //lets get the model for this page
        this._data.getModelData(queryData) 
        .pipe(first())
        .subscribe(
          data => {
  
            let status = data['covers'][0]['cover']['model']['modelData']['systemManagedEntities']['paymentDetails']['status'];
            if(status == "COMPLETE") {
              this.checkComplete = true
              this.router.navigate(['/shop/checkout/complete']);
            }
  
            if(status == "FAILED") {
              this.checkComplete = true
              this.router.navigate(['/shop/checkout/failure']);
            }
  
            else {
              console.log('status not yet ready')
                    setTimeout(()=>{    //<<<---    using ()=> syntax
                      this.trackPaymentStatus();
                }, 6000);
        
              
            }
            
          },
          error => {
  
              // $('#loader').hide();
  
          },
  
          () => {
            // $('#loader').hide();
            // this.reviewOrderSummary()
          }
        );
    }

  }

}
